var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7716 1.58722C19.7495 1.92407 21.4567 3.2182 22.3728 5.07501C23.59 7.57147 23.1125 10.6019 21.193 12.562L12.2083 22.2C12.0276 22.3937 11.7793 22.5029 11.52 22.5029C11.2607 22.5029 11.0124 22.3937 10.8317 22.2L1.8336 12.544C-0.0762367 10.5848 -0.546349 7.56207 0.672001 5.07501C1.57339 3.2085 3.28389 1.90967 5.2656 1.58698C7.25874 1.23645 9.29177 1.90936 10.7251 3.39398L11.52 4.14801L12.3437 3.367C13.7797 1.91077 15.7937 1.25037 17.7716 1.58722ZM11.8627 19.696L19.8307 11.151C21.1626 9.80151 21.4986 7.70721 20.6602 5.97998C20.0342 4.68536 18.847 3.78491 17.472 3.56201C16.0833 3.31812 14.6669 3.78729 13.6685 4.82196L12.1699 6.245C11.8035 6.59271 11.2432 6.59271 10.8768 6.245L9.408 4.84497C8.4055 3.79456 6.97599 3.31622 5.57376 3.56201C4.1971 3.78375 3.00795 4.68427 2.3808 5.97998C1.54289 7.6994 1.87199 9.78619 3.19392 11.136L11.1744 19.696C11.2648 19.7928 11.3889 19.8475 11.5186 19.8475C11.6482 19.8475 11.7723 19.7928 11.8627 19.696Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ec249a95.svg";
export { ForwardRef as ReactComponent };